import { Box, Typography } from '@mui/material'
import PercentileChartElementBar, {
  PercentileBarColorOptions,
} from 'components/PercentileChartElement/Bar'
import PercentileChartElementCohort, {
  PercentileCohortData,
} from 'components/PercentileChartElement/Cohort'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import React from 'react'
// import { KeyRatingsChartElementRowProps } from './Row'

export type KeyRatingsChartElementPrintRowProps = {
  title: string
  description: string
  chartPercentage: any
  averageData: string
  chartValue: any
  colorPalette: PercentileBarColorOptions
  data: any
  cohortData: PercentileCohortData | undefined
  showTrendCol: boolean
  showTrendNa: boolean
  lineChartOptions: any
}

const KeyRatingsChartElementPrintRow: React.FC<
  KeyRatingsChartElementPrintRowProps
> = ({
  title,
  description,
  chartPercentage,
  averageData,
  chartValue,
  colorPalette,
  data,
  cohortData,
  showTrendCol,
  showTrendNa,
  lineChartOptions,
}) => {
  const titleStyle = {
    verticalAlign: 'middle',
    paddingLeft: '32px',
    paddingTop: '16px',
    paddingBottom: '16px',
    borderTop: '1px solid #E0E0E0',
    borderLeft: '1px solid #E0E0E0',
  }
  const averageStyle = {
    verticalAlign: 'middle',
    paddingLeft: '32px',
    paddingTop: '16px',
    paddingBottom: '16px',
    borderTop: '1px solid #E0E0E0',
  }
  const percentileStyle = {
    verticalAlign: 'middle',
    paddingLeft: '32px',
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingRight: showTrendCol ? '0px' : '32px',
    borderTop: '1px solid #E0E0E0',
    borderRight: showTrendCol ? 'none' : '1px solid #E0E0E0',
  }
  const trendStyle = {
    verticalAlign: 'middle',
    paddingLeft: '32px',
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingRight: '32px',
    borderTop: '1px solid #E0E0E0',
    borderRight: '1px solid #E0E0E0',
  }

  return (
    <tr style={{ breakInside: 'avoid' }}>
      <td style={titleStyle}>
        <Typography variant="h5">{title}</Typography>
        {description && (
          <Typography component="p" sx={{ fontSize: '0.8rem' }}>
            {description}
          </Typography>
        )}
      </td>
      <td style={averageStyle}>
        {chartPercentage !== null && chartPercentage !== undefined && (
          <Typography align="center" component="div" variant="h4">
            {averageData}
          </Typography>
        )}
      </td>
      <td style={percentileStyle}>
        <Box sx={{ width: '100%' }}>
          {chartPercentage !== null && chartPercentage !== undefined ? (
            <PercentileChartElementBar
              percentage={chartPercentage}
              showBoldPercentile
              label=""
              value={chartValue}
              prefix={data.prefix}
              suffix={data.suffix}
              significantDigits={data.absolutes}
              size={40}
              color={colorPalette}
            />
          ) : (
            <Typography align="center">N/A</Typography>
          )}
        </Box>
        {cohortData && (
          <Box>
            {chartPercentage !== null && chartPercentage !== undefined && (
              <>
                <PercentileChartElementCohort
                  data={
                    cohortData || {
                      max: 0,
                      median: 0,
                      min: 0,
                      name: '',
                    }
                  }
                  size={20}
                  hideLabel
                />
                <Typography component="small" sx={{ fontSize: '12px' }}>
                  {cohortData.name}
                </Typography>
              </>
            )}
          </Box>
        )}
      </td>
      {showTrendCol && (
        <td style={trendStyle}>
          <Box
            sx={{
              borderTop: !showTrendNa ? '1px solid #BDBDBD' : '',
              borderBottom: !showTrendNa ? '1px solid #BDBDBD' : '',
            }}
          >
            {showTrendNa ? (
              <Typography align="center">N/A</Typography>
            ) : (
              <HighchartsReact
                highcharts={Highcharts}
                options={lineChartOptions}
              ></HighchartsReact>
            )}
          </Box>
        </td>
      )}
    </tr>
  )
}

export default KeyRatingsChartElementPrintRow
